import React from 'react';
import { useFormContext } from 'react-hook-form';
import AddressForm from '../address-form/AddressForm';
import './Step4DeliveryInfo.scss';

const Step4DeliveryInfo = ({ onSubmitFromStep4, isSubmitting, readOnly = false }) => {
  const { register, formState: { errors } } = useFormContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (readOnly) return;
    if (onSubmitFromStep4) {
      await onSubmitFromStep4(4);
    }
  };

  return (
    <div className="step-4-delivery-info">
      <fieldset disabled={readOnly}>
        <AddressForm
          title="Delivery Location" 
          prefix="delivery"
          required={true}
        />
        
        <div className="delivery-notes-section">
          <div className="form-group full-width">
            <label htmlFor="delivery.notes">
              Delivery Notes
            </label>
            <textarea
              id="delivery.notes"
              placeholder="Text"
              rows={4}
              {...register('delivery.notes')}
              className={errors.delivery?.notes ? 'error' : ''}
            />
            {errors.delivery?.notes && (
              <span className="error-message">{errors.delivery.notes.message}</span>
            )}
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default Step4DeliveryInfo;














